module.exports = __webpack_public_path__ + "0a20d1aceb5b5266f21a264c76df8d98.webp";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/LynksExport/assets/Sec-2/icon_3.webp
// module id = ./app/containers/StaticPage/LynksExport/assets/Sec-2/icon_3.webp
// module chunks = 40